import apiClient from './client';
import type { LoginResponse, RoleConfig, User } from '@/types/auth';

export async function login(username: string, password: string): Promise<LoginResponse> {
  const response = await apiClient.post<LoginResponse>('/auth/login', { username, password });
  return response.data as unknown as LoginResponse;
}

export async function getMe(): Promise<User> {
  const response = await apiClient.get<User>('/auth/me');
  return response.data as unknown as User;
}

export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  await apiClient.put('/auth/me/password', { old_password: oldPassword, new_password: newPassword });
}

export async function listUsers(): Promise<User[]> {
  const response = await apiClient.get<User[]>('/auth/users');
  return response.data as unknown as User[];
}

export async function createUser(data: {
  username: string;
  password: string;
  display_name?: string;
  role: string;
  tenant_id: string;
  permissions: string[];
}): Promise<User> {
  const response = await apiClient.post<User>('/auth/users', data);
  return response.data as unknown as User;
}

export async function updateUser(userId: string, data: Partial<User> & { password?: string }): Promise<User> {
  const response = await apiClient.put<User>(`/auth/users/${userId}`, data);
  return response.data as unknown as User;
}

export async function deleteUser(userId: string): Promise<void> {
  await apiClient.delete(`/auth/users/${userId}`);
}

export async function listRoles(): Promise<RoleConfig[]> {
  const response = await apiClient.get<RoleConfig[]>('/auth/roles');
  return response.data as unknown as RoleConfig[];
}

export async function saveRoles(roles: RoleConfig[]): Promise<RoleConfig[]> {
  const response = await apiClient.put<RoleConfig[]>('/auth/roles', { roles });
  return response.data as unknown as RoleConfig[];
}
